/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>validation.service.ts</name>
///
/// <description>
///  The mediator service will mediate events between the various UI entities
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>15 Aug 2017</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 15Aug17 MM  1.0.0000         First cut 
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Injectable, Input } from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {Http, Response} from '@angular/http';
import { AbstractControl, FormsModule, ReactiveFormsModule, FormBuilder, Validators, ValidatorFn, FormGroup, FormControl } from '@angular/forms';

@Injectable()
export class ValidationService {


    //----------------------------------------------------------
    // IpAddress
    //----------------------------------------------------------
    public IpAddress(c: FormControl) {


        //let IP_REGEXP: RegExp = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/;
        let IP_REGEXP: RegExp = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;


        if (c.value !== null && c.value !== "0.0.0.0" && IP_REGEXP.test(c.value)) {
            return null;
        }
        else {
            return {
                IpAddress: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // IpAddress
    //----------------------------------------------------------
    public IpAddressCFA(c: FormControl) {


        let IP_REGEXP: RegExp = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;


        if ((c.value === "" || c.value === null) || (c.value !== null && c.value !== "0.0.0.0" && IP_REGEXP.test(c.value))) {
            return null;
        }
        else {
            return {
                IpAddressCFA: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // URL
    //----------------------------------------------------------
    public URL(c: FormControl) {

        //MM - Bug 126055
        let URL_REGEXP: RegExp = /http(s)?:\/\/?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;

        if (c.value === null || c.value === "" || (c.value !== null && URL_REGEXP.test(c.value) && (c.value.indexOf(' ') < 0))) {
            return null;
        }
        else {
            return {
                URL: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // CloudURL
    //----------------------------------------------------------
    public CloudURL(c: FormControl) {

        let URL_REGEXP: RegExp = /^(http|https):\/\/[^ "]+$/;


        if (c.value !== null && URL_REGEXP.test(c.value) && (c.value.indexOf(' ') < 0) && c.value.toString().length <= 255) {
            return null;
        }
        else {
            return {
                URL: {
                    valid: false
                }
            }
        }
    }



    //----------------------------------------------------------
    // SpeedKey
    //----------------------------------------------------------
    public SpeedKey(c: FormControl) {


        if (c.value !== null && c.value.toString().trim() !== "" && !isNaN(c.value) && c.value.toString().length <= 15) {
            return null;
        }
        else {
            return {
                SpeedKey: {
                    valid: false
                }
            }
        }
    }



    //----------------------------------------------------------
    // CustomString
    //----------------------------------------------------------
    public CustomStringCFA(c: FormControl) {


        if (c.value !== null && c.value.toString().trim() !== "" && c.value.toString().length <= 40) {
            return null;
        }
        else {
            return {
                CustomStringCFA: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // SpeedKeyName
    //----------------------------------------------------------
    public SpeedKeyName(c: FormControl) {

        if (c.value !== null && c.value.toString().trim() !== "" && c.value.toString().length <= 20) {
            return null;
        }
        else {
            return {
                SpeedKeyName: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // DomainName
    //----------------------------------------------------------
    public DomainName(c: FormControl) {


        let DOMAIN_REGEXP: RegExp = /^[\w\-\.]+$/;
        if (c.value === null || c.value === "" || (c && c.value && DOMAIN_REGEXP.test(c.value) && c.value.length > 0 && c.value.length <= 40)) {
            return null;
        }
        else {
            return {
                DomainName: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Numeric
    //----------------------------------------------------------
    public Numeric(c: FormControl) {


        //MM - Bug 138071 - Issue #1
        let NUMERIC_REGEXP: RegExp = /^[0-9]*$/;
        if (c.value !== null && NUMERIC_REGEXP.test(c.value)) {
            return null;
        }
        else {
            return {
                Numeric: {
                    valid: false
                }
            }
        }

    }
    //----------------------------------------------------------
    // MinutesLong
    //----------------------------------------------------------
    public MinutesLong(c: FormControl) {


        if (c.value && c.value !== null && c.value.toString().trim() !== "" && !isNaN(c.value) && c.value > 0 && c.value <= 120) {
            return null;
        }
        else {
            return {
                MinutesLong: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Minutes
    //----------------------------------------------------------
    public Minutes(c: FormControl) {


        if (c.value !== null && c.value.toString().trim() !== "" && !isNaN(c.value) && c.value >= 0 && c.value <= 60) {
            return null;
        }
        else {
            return {
                Minutes: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // BackgroundInterval
    //----------------------------------------------------------
    public BackgroundInterval(c: FormControl) {


        if (c.value === null || c.value === "" || (c.value !== null && !isNaN(c.value) && c.value >= 30 && c.value <= 600)) {
            return null;
        }
        else {
            return {
                BackgroundInterval: {
                    valid: false
                }
            }
        }
    }


    //----------------------------------------------------------
    // Bluetooth
    //----------------------------------------------------------
    public Bluetooth(c: FormControl) {

        let BLUETOOTH_REGEXP: RegExp = /^[\w\-]+$/;

        if (c.value === null || c.value === "" || (c.value !== null && BLUETOOTH_REGEXP.test(c.value) && c.value.toString().length <= 8)) {
            return null;
        }
        else {
            return {
                Bluetooth: {
                    valid: false
                }
            }
        }
    }
    //----------------------------------------------------------
    // DisplayPort
    //----------------------------------------------------------
    public DisplayPort(c: FormControl) {


        if (c.value === null || c.value === "" || (c.value !== null && !isNaN(c.value) && (c.value >= 0 && c.value <= 65535))) {
            return null;
        }
        else {
            return {
                DisplayPort: {
                    valid: false
                }
            }
        }
    }
    //----------------------------------------------------------
    // Port
    //----------------------------------------------------------
    public Port(c: FormControl) {


        if (c.value !== null && (!isNaN(c.value) && (c.value >= 1025 && c.value < 65536))) {
            return null;
        }
        else {
            return {
                Port: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Code
    //----------------------------------------------------------
    public LoginCode(c: FormControl) {


        if (c.value !== null && !isNaN(c.value) && (c.value >= 0) && (c.value <= 9999) && (c.value.toString().length === 4)) {
            return null;
        }
        else {
            return {
                Code: {
                    valid: false
                }
            }
        }
    }



    //----------------------------------------------------------
    // ProxyServer
    //----------------------------------------------------------
    public ProxyServer(c: FormControl, length: number) {


        if (c.value && c.value !== null && c.value.length <= 63) {
            return null;
        }
        else {
            return {
                ProxyServer: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Length
    //----------------------------------------------------------
    public Length(c: FormControl, length: number) {


        if (c.value.toString().length <= 4) {
            return null;
        }
        else {
            return {
                Length: {
                    valid: false
                }
            }
        }
    }


    //----------------------------------------------------------
    // Email
    //----------------------------------------------------------
    public Email(c: FormControl) {


        let EMAIL_REGEXP: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (c.value === null || c.value === "" || (c.value !== null && EMAIL_REGEXP.test(c.value))) {
            return null;
        }
        else {
            return {
                Email: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Domain
    //----------------------------------------------------------
    public Domain(c: FormControl) {

        let result: boolean = false;
        let ip: boolean = false;
        let url: boolean = false;
        let domain: boolean = false;

        let IP_REGEXP: RegExp = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;
        let URL_REGEXP: RegExp = /http(s)?:\/\/?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
        let DOMAIN_REGEXP: RegExp = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;

        if (c.value === undefined) {
            result = false;
        }
        else if (c.value === null || c.value === "") {
            result = true;//MM -Bug 138763 , empty is valid
        }
        else {

            //MM - Bug 144871 - Domain should be 127 chars, no longer 253
            if (c.value !== null && DOMAIN_REGEXP.test(c.value) && (c.value.length <= 127)) {
                domain = true;
            }
            if (c.value !== null && IP_REGEXP.test(c.value)) {
                ip = true;
            }
            if (c.value !== null && URL_REGEXP.test(c.value) && (c.value.indexOf(' ') < 0)) {
                url = true;
            }


            if ((url || domain) && !ip) {//if not valid ip address, then check for 3 dots 
                let count = (c.value.match(RegExp('\\.', 'g')) || []).length;
                if (count <= 2) {
                    result = true;
                }
            }
            else if (ip || url || domain) {
                result = true;
            }

        }

        if (result) {
            return null;
        }
        else {
            return {
                Domain: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // DomainCE
    //----------------------------------------------------------
    public DomainCE(c: FormControl) {

        let result: boolean = false;
        let ip: boolean = false;
        let url: boolean = false;
        let domain: boolean = false;

        let IP_REGEXP: RegExp = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;
        let URL_REGEXP: RegExp = /http(s)?:\/\/?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
        let DOMAIN_REGEXP: RegExp = /^(([A-Z0-9]|[A-Z0-9][A-Z0-9\-]*[A-Z0-9])\.)*([A-Z0-9]|[A-Z0-9][A-Z0-9\-]*[A-Z0-9])$/;//MM -Bug 138763, lower case is not valid

        if (c.value === undefined) {
            result = false;
        }
        else if (c.value === null || c.value === "") {
            result = true;//MM -Bug 138763  , empty is valid
        }
        else {

            //MM - Bug 144871 - Domain should be 59 chars, no longer 60
            if (c.value !== null && DOMAIN_REGEXP.test(c.value) && (c.value.length <= 59)) {
                domain = true;
            }
            if (c.value !== null && IP_REGEXP.test(c.value)) {
                ip = true;
            }
            if (c.value !== null && URL_REGEXP.test(c.value) && (c.value.indexOf(' ') < 0)) {
                url = true;
            }


            if ((url || domain) && !ip) {//if not valid ip address, then check for 3 dots 
                let count = (c.value.match(RegExp('\\.', 'g')) || []).length;
                if (count <= 2) {
                    result = true;
                }
            }
            else if (ip || url || domain) {
                result = true;
            }

        }

        if (result) {
            return null;
        }
        else {
            return {
                DomainCE: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // DomainCFA
    //----------------------------------------------------------
    public DomainCFA(c: FormControl) {

        let result: boolean = false;
        let ip: boolean = false;
        let url: boolean = false;
        let domain: boolean = false;

        let IP_REGEXP: RegExp = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;
        let URL_REGEXP: RegExp = /http(s)?:\/\/?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
        let DOMAIN_REGEXP: RegExp = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;//DA-Bug 146520, allow lower case for mercury

        if (c.value === undefined) {
            result = false;
        }
        else if (c.value === null || c.value === "") {
            result = true;
        }
        else {

            //MM - Bug 144871 - Domain should be 59 chars, no longer 60
            if (c.value !== null && DOMAIN_REGEXP.test(c.value) && (c.value.length <= 59)) {
                domain = true;
            }
            if (c.value !== null && IP_REGEXP.test(c.value)) {
                ip = true;
            }
            if (c.value !== null && URL_REGEXP.test(c.value) && (c.value.indexOf(' ') < 0)) {
                url = true;
            }


            if ((url || domain) && !ip) {//if not valid ip address, then check for 3 dots 
                let count = (c.value.match(RegExp('\\.', 'g')) || []).length;
                if (count <= 2) {
                    result = true;
                }
            }
            else if (ip || url || domain) {
                result = true;
            }

        }

        if (result) {
            return null;
        }
        else {
            return {
                DomainCFA: {
                    valid: false
                }
            }
        }
    }


    //----------------------------------------------------------
    //HostName 
    //----------------------------------------------------------
    public HostName(c: FormControl) {

        let HOST_REGEXP: RegExp = /^([0-9a-zA-Z][0-9a-zA-Z-]*[0-9a-zA-Z])$/;
        let maxLength: number = 63;

        if (c.value && c.value !== null && HOST_REGEXP.test(c.value) && c.value.length >= 2 && c.value.length <= maxLength) {
            return null;
        }
        else {
            return {
                HostName: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    //HostNameCE
    //----------------------------------------------------------
    public HostNameCE(c: FormControl) {

        let HOST_REGEXP: RegExp = /^([0-9A-Z][0-9A-Z-]*[0-9A-Z])$/;
        let maxLength: number = 15;

        if (c.value && c.value !== null
            && HOST_REGEXP.test(c.value)
            && c.value.length >= 2 && c.value.length <= maxLength) {
            return null;
        }
        else {
            return {
                HostNameCE: {
                    valid: false
                }
            }
        }
    }


    //----------------------------------------------------------
    //HostNameGeneric
    //----------------------------------------------------------
    public HostNameGeneric(maxLength: number) {

        let HOST_REGEXP: RegExp = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;


        return (c: FormControl) => {

            let isValid: boolean = (c.value && c.value !== null && HOST_REGEXP.test(c.value) && c.value.length >= 2 && c.value.length <= maxLength);
            return (isValid) ? null : { 'HostNameGeneric': { valid: isValid } };


        }
    }


    //----------------------------------------------------------
    // LocalExtension
    //----------------------------------------------------------
    public LocalExtension(c: FormControl) {

        //YH 4/20/2017 Bug 127561 - Local extension should allow alphanumeric characters
        //if (c.value === null || c.value === "" || (c.value !== null && !isNaN(c.value) && c.value > 0 && c.value.toString().length <= 64)) {
        let LOCALEXT_REGEXP: RegExp = /^\w{1,15}$/;
        if (c.value !== null && LOCALEXT_REGEXP.test(c.value)) {

            return null;
        }
        else {
            return {
                LocalExtension: {
                    valid: false
                }
            }
        }
    }


    //----------------------------------------------------------
    // LocalExtensionCE
    //----------------------------------------------------------
    public LocalExtensionCFA(c: FormControl) {

        let LOCALEXT_REGEXP: RegExp = /^[a-zA-Z0-9!~@#*&%$^()_+\`\[\]-{};=':\\|,.<>\/?]*$/;

        if (c.value !== null && c.value !== "" && LOCALEXT_REGEXP.test(c.value) && c.value.length <= 127) {

            return null;
        }
        else {
            return {
                LocalExtensionCE: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // DisplayExtensionSIP
    //----------------------------------------------------------
    public DisplayExtensionAPPSPACE(c: FormControl) {

        let DISPLAYEXT_REGEXP: RegExp = /^[a-zA-Z0-9!"~@#*&%$^()_+\`\[\]-{};=':\\|,.<>\/?]*$/;
        if (c.value !== null && c.value !== "") {
            if (DISPLAYEXT_REGEXP.test(c.value) && c.value.length <= 12) {

                return null;
            }
            else {
                return {
                    DisplayExtension: {
                        valid: false
                    }
                }
            }
        }
        return null;
    }

    ///-------------
    //PortSipValidation
    ///--------
    public PortSipValidation(c: FormControl) {
        if (c.value !== null && c.value !== "" && (c.value >= 1025 && c.value <=65535)) {

            return null;
        }
        else {
            return {
                LocalExtensionCE: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // DisplayExtensionSFB
    //----------------------------------------------------------
    public DisplayExtensionSFBAPPSPACE(c: FormControl) {

        let DISPLAYEXT_REGEXP: RegExp = /^[a-zA-Z0-9]*$/;
        if (c.value !== null && c.value !== "") {
            if (DISPLAYEXT_REGEXP.test(c.value) && c.value.length <= 12) {

                return null;
            }
            else {
                return {
                    DisplayExtensionSFB: {
                        valid: false
                    }
                }
            }
        }
        return null;
    }

    //----------------------------------------------------------
    // ServerURL AppSpace
    //----------------------------------------------------------
    public ServerURLAppSpace(c: FormControl) {

        if (c.value !== null && c.value !== "") {
            if (c.value.length <= 255) {

                return null;
            }
            else {
                return {
                    ServerRUL: {
                        valid: false
                    }
                }
            }
        }
        return null;
    }


    //----------------------------------------------------------
    // SystemName
    //----------------------------------------------------------
    public SystemName(c: FormControl) {


        if (c && c.value && c.value.trim().length > 0 && c.value.length <= 20) {
            return null;
        }
        else {
            return {
                SystemName: {
                    valid: false
                }
            }
        }
    }
    //----------------------------------------------------------
    // SchedulingPassword
    //----------------------------------------------------------
    public SchedulingPassword(c: FormControl) {


        if (c.value === null || c.value === "" || (c && c.value && c.value.length > 0 && c.value.length <= 30)) {
            return null;
        }
        else {
            return {
                SchedulingPassword: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Password
    //----------------------------------------------------------
    public Password(c: FormControl) {


        if (c.value !== null && c.value.length > 0 && c.value.length <= 50) {
            return null;
        }
        else {
            return {
                Password: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // ServerPassword
    //----------------------------------------------------------
    public ServerPassword(c: FormControl) {


        if (c && c.value && c.value.length > 0 && c.value.length <= 64) {
            return null;
        }
        else {
            return {
                ServerPassword: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // ServerPasswordCE
    //----------------------------------------------------------
    public ServerPasswordCFA(c: FormControl) {

        let SERVERPASSWORD_REGEXP: RegExp = /^[a-zA-Z0-9!"~@#*&%$^()_+\`\[\]-{};=':\\|,.<>\/?]*$/;

        //if (c.value !== null && SERVERPASSWORD_REGEXP.test(c.value)) {
        if (c && c.value && c.value.length > 0 && c.value.length <= 127) {

            return null;
        }
        else {
            return {
                ServerPasswordCFA: {
                    valid: false
                }
            }
        }
    }


    //----------------------------------------------------------
    // SchedulingUserName
    //----------------------------------------------------------
    public SchedulingUserName(c: FormControl) {

        let USERNAME_REGEXP: RegExp = /^[\w\-\.]+$/;
        if (c && c.value && USERNAME_REGEXP.test(c.value) && c.value.length > 0 && c.value.length <= 30) {
            return null;
        }
        else {
            return {
                SchedulingUserName: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // UserName
    //----------------------------------------------------------
    public UserName(c: FormControl) {


        if (c && c.value && c.value.trim().length > 0 && c.value.length <= 64) {
            return null;
        }
        else {
            return {
                UserName: {
                    valid: false
                }
            }
        }
    }


    //----------------------------------------------------------
    // UserNameCE
    //----------------------------------------------------------
    public UserNameCFA(c: FormControl) {

        let USERNAME_REGEXP: RegExp = /^[a-zA-Z0-9!~@#*&%$^()_+\`\[\]-{};=':\\|,.<>\/?]*$/;

        if (c.value !== null && c.value !== "" && USERNAME_REGEXP.test(c.value) && c.value.length <= 127) {

            return null;
        }
        else {
            return {
                UserNameCFA: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // RoomName
    //----------------------------------------------------------
    public RoomName(c: FormControl) {

        //Room Name 1 to 40 Characters. 
        //Characters allowed: abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 _()-/	

        let ROOMNAME_REGEXP: RegExp = /^[a-zA-Z0-9 _()\/-]*$/;
        if (c.value === null || c.value === "" || (c && c.value && ROOMNAME_REGEXP.test(c.value) && c.value.trim().length > 0 && c.value.length <= 40)) {
            return null;
        }
        else {
            return {
                RoomName: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Realm
    //----------------------------------------------------------
    public Realm(c: FormControl) {

        let REALM_REGEXP: RegExp = /^[^&]+$/;
        if (c.value !== null && (c.value.trim().length > 0 && c.value.length <= 64 && REALM_REGEXP.test(c.value))) {
            return null;
        }
        else {
            return {
                Realm: {
                    valid: false
                }
            }
        }
    }


    //----------------------------------------------------------
    // UserNameCE
    //----------------------------------------------------------
    public RealmCFA(c: FormControl) {

        let REALM_REGEXP: RegExp = /^[a-zA-Z0-9!~@#*&%$^()_+\`\[\]-{};=':\\|,.<>\/?]*$/;

        if (c.value !== null && c.value !== "" && REALM_REGEXP.test(c.value) && c.value.length <= 127) {

            return null;
        }
        else {
            return {
                RealmCFA: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Channel
    //----------------------------------------------------------
    public Channel(c: FormControl) {


        if (c.value === null || c.value === "" || (c.value !== null && !isNaN(c.value) && (c.value >= 1) && (c.value <= 255))) {
            return null;
        }
        else {
            return {
                Channel: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // IPorHostName
    //----------------------------------------------------------
    public IPorHostName(c: FormControl) {

        let result: boolean = false;
        let ip: boolean = false;
        let hostname: boolean = false;

        let IP_REGEXP: RegExp = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;
        let HOST_REGEXP: RegExp = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;


        if (c.value !== undefined && c.value !== null && c.value !== "0.0.0.0" && IP_REGEXP.test(c.value)) {
            ip = true;
        }
        if (c.value !== undefined && c.value !== null && HOST_REGEXP.test(c.value)) {
            hostname = true;
        }

        if (hostname && !ip) {//if not valid ip address, then check for 3 dots 
            let count = (c.value.match(RegExp('\\.', 'g')) || []).length;
            if (count <= 2) {
                result = true;
            }
        }
        else if (ip || hostname) {
            result = true;
        }


        if (result) {
            return null;
        }
        else {
            return {
                IPorHostName: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // IPorHostName
    //----------------------------------------------------------
    public IPorHostNameCFA(c: FormControl) {

        let result: boolean = false;
        let ip: boolean = false;
        let hostname: boolean = false;

        let IP_REGEXP: RegExp = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[1-4]))$/;
        let HOST_REGEXP: RegExp = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/;


        if (c.value !== undefined && c.value !== null && c.value !== "0.0.0.0" && c.value !== " 255.255.255.255" && IP_REGEXP.test(c.value) && c.value.length <= 127) {
            ip = true;
        }
        if (c.value !== undefined && c.value !== null && HOST_REGEXP.test(c.value) && c.value.length <= 127) {
            hostname = true;
        }

        if (hostname && !ip) {//if not valid ip address, then check for 3 dots 
            let count = (c.value.match(RegExp('\\.', 'g')) || []).length;
            if (count <= 2) {
                result = true;
            }
        }
        else if (ip || hostname) {
            result = true;
        }


        if (result) {
            return null;
        }
        else {
            return {
                IPorHostNameCFA: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Server
    //----------------------------------------------------------
    public Server(c: FormControl) {

        let result: boolean = false;
        let ip: boolean = false;
        let url: boolean = false;
        let server: boolean = false;

        let IP_REGEXP: RegExp = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;
        let URL_REGEXP: RegExp = /http(s)?:\/\/?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
        let SERVER_REGEXP: RegExp = /^[\w\.\-]+$/;

        if (c.value !== undefined) {
            if (c.value !== null && IP_REGEXP.test(c.value)) {
                ip = true;
            }
            if (c.value !== null && URL_REGEXP.test(c.value) && (c.value.indexOf(' ') < 0)) {
                url = true;
            }
            if (c.value !== null && SERVER_REGEXP.test(c.value)) {
                server = true;
            }

            if ((url || server) && !ip) {//if not valid ip address, then check for 3 dots 
                let count = (c.value.match(RegExp('\\.', 'g')) || []).length;
                if (count <= 2 || (server && count > 2)) {
                    result = true;
                }
            }
            else if (ip || url || server) {
                result = true;
            }
        }


        if (result) {
            return null;
        }
        else {
            return {
                Server: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // CustomServer
    //----------------------------------------------------------
    public CustomServer(c: FormControl) {

        let SERVER_REGEXP: RegExp = /^[\w\.\-]+$/;


        if (c.value === null || c.value === "" || (c.value !== null && SERVER_REGEXP.test(c.value))) {
            return null;
        }
        else {
            return {
                CustomServer: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // Time
    //----------------------------------------------------------
    public Time(c: FormControl) {

        let TIME_REGEXP: RegExp = /\b((1[0-2]|0?[0-9]):([0-5][0-9]) ([AaPp][Mm]))/g;


        if (c.value === null || c.value === "" || (c.value !== null && TIME_REGEXP.test(c.value))) {
            return null;
        }
        else {
            return {
                Time: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // UPN
    //----------------------------------------------------------
    public UPN(c: FormControl) {


        let UPN_REGEXP: RegExp = /^[a-zA-Z0-9-_.\\]+$|[A-Za-z0-9._%+-]+@[A-za-z0-9.-]+\.[A-Za-z]{2,}$/;

        if (c.value === null || c.value === "" || (c.value !== null && UPN_REGEXP.test(c.value))) {
            return null;
        }
        else {
            return {
                UPN: {
                    valid: false
                }
            }
        }
    }

    //----------------------------------------------------------
    // ExternalURL
    //----------------------------------------------------------
    public ExternalURL(c: FormControl) {

        let result: boolean = false;
        let url: boolean = false;
        let domain: boolean = false;

        let URL_REGEXP: RegExp = /^(?:http|https?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
        let DOMAIN_REGEXP: RegExp = /[\w\-\.]+$/;

        if (c.value === null || c.value === "" || c.value === undefined) {
            return null;
        }
        else {

            //if (c.value !== null && DOMAIN_REGEXP.test(c.value) && (c.value.length <= 253)) {
            //    domain = true;
            //}
            if (c.value !== null && URL_REGEXP.test(c.value) && (c.value.indexOf(' ') < 0)) {
                url = true;
            }


            if (url) {
                result = true;
            }

        }

        if (result) {
            return null;
        }
        else {
            return {
                ExternalURL: {
                    valid: false
                }
            }
        }
    }





} 


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/validation.service.ts